export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_StrengthDesc_03.8a5f966e.jpg";